import Keycloak from 'keycloak-js';
import {KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM, KEYCLOAK_URL} from "./settings";

const config = {
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
  url: KEYCLOAK_URL
};

const _kc = new Keycloak(config);

export default _kc;